// From https://github.com/blossomfinance/iso-4217-currencies/blob/0be5dbc3c9d75f10debecb7b840d1a156fe0ce69/data/iso-3166-1-alpha-2-to-iso-4217.json
export const countryCodeToCurrency = {
    AD: 'EUR' as const,
    AE: 'AED' as const,
    AF: 'AFN' as const,
    AG: 'XCD' as const,
    AI: 'XCD' as const,
    AL: 'ALL' as const,
    AM: 'AMD' as const,
    AO: 'AOA' as const,
    AQ: 'USD' as const,
    AR: 'ARS' as const,
    AS: 'USD' as const,
    AT: 'EUR' as const,
    AU: 'AUD' as const,
    AW: 'AWG' as const,
    AX: 'EUR' as const,
    AZ: 'AZN' as const,
    BA: 'BAM' as const,
    BB: 'BBD' as const,
    BD: 'BDT' as const,
    BE: 'EUR' as const,
    BF: 'XOF' as const,
    BG: 'BGN' as const,
    BH: 'BHD' as const,
    BI: 'BIF' as const,
    BJ: 'XOF' as const,
    BL: 'EUR' as const,
    BM: 'BMD' as const,
    BN: 'BND' as const,
    BO: 'BOB' as const,
    BQ: 'USD' as const,
    BR: 'BRL' as const,
    BS: 'BSD' as const,
    BT: 'BTN' as const,
    BV: 'NOK' as const,
    BW: 'BWP' as const,
    BY: 'BYR' as const,
    BZ: 'BZD' as const,
    CA: 'CAD' as const,
    CC: 'AUD' as const,
    CD: 'CDF' as const,
    CF: 'XAF' as const,
    CG: 'XAF' as const,
    CH: 'CHF' as const,
    CI: 'XOF' as const,
    CK: 'NZD' as const,
    CL: 'CLP' as const,
    CM: 'XAF' as const,
    CN: 'CNY' as const,
    CO: 'COP' as const,
    CR: 'CRC' as const,
    CU: 'CUP' as const,
    CV: 'CVE' as const,
    CW: 'ANG' as const,
    CX: 'AUD' as const,
    CY: 'EUR' as const,
    CZ: 'CZK' as const,
    DE: 'EUR' as const,
    DJ: 'DJF' as const,
    DK: 'DKK' as const,
    DM: 'XCD' as const,
    DO: 'DOP' as const,
    DZ: 'DZD' as const,
    EC: 'USD' as const,
    EE: 'EUR' as const,
    EG: 'EGP' as const,
    EH: 'MAD' as const,
    ER: 'ERN' as const,
    ES: 'EUR' as const,
    ET: 'ETB' as const,
    FI: 'EUR' as const,
    FJ: 'FJD' as const,
    FK: 'FKP' as const,
    FM: 'USD' as const,
    FO: 'DKK' as const,
    FR: 'EUR' as const,
    GA: 'XAF' as const,
    GB: 'GBP' as const,
    GD: 'XCD' as const,
    GE: 'GEL' as const,
    GF: 'EUR' as const,
    GG: 'GBP' as const,
    GH: 'GHS' as const,
    GI: 'GIP' as const,
    GL: 'DKK' as const,
    GM: 'GMD' as const,
    GN: 'GNF' as const,
    GP: 'EUR' as const,
    GQ: 'XAF' as const,
    GR: 'EUR' as const,
    GS: 'GBP' as const,
    GT: 'GTQ' as const,
    GU: 'USD' as const,
    GW: 'XOF' as const,
    GY: 'GYD' as const,
    HK: 'HKD' as const,
    HM: 'AUD' as const,
    HN: 'HNL' as const,
    HR: 'HRK' as const,
    HT: 'HTG' as const,
    HU: 'HUF' as const,
    ID: 'IDR' as const,
    IE: 'EUR' as const,
    IL: 'ILS' as const,
    IM: 'GBP' as const,
    IN: 'INR' as const,
    IO: 'USD' as const,
    IQ: 'IQD' as const,
    IR: 'IRR' as const,
    IS: 'ISK' as const,
    IT: 'EUR' as const,
    JE: 'GBP' as const,
    JM: 'JMD' as const,
    JO: 'JOD' as const,
    JP: 'JPY' as const,
    KE: 'KES' as const,
    KG: 'KGS' as const,
    KH: 'KHR' as const,
    KI: 'AUD' as const,
    KM: 'KMF' as const,
    KN: 'XCD' as const,
    KP: 'KPW' as const,
    KR: 'KRW' as const,
    KW: 'KWD' as const,
    KY: 'KYD' as const,
    KZ: 'KZT' as const,
    LA: 'LAK' as const,
    LB: 'LBP' as const,
    LC: 'XCD' as const,
    LI: 'CHF' as const,
    LK: 'LKR' as const,
    LR: 'LRD' as const,
    LS: 'LSL' as const,
    LT: 'LTL' as const,
    LU: 'EUR' as const,
    LV: 'EUR' as const,
    LY: 'LYD' as const,
    MA: 'MAD' as const,
    MC: 'EUR' as const,
    MD: 'MDL' as const,
    ME: 'EUR' as const,
    MF: 'EUR' as const,
    MG: 'MGA' as const,
    MH: 'USD' as const,
    MK: 'MKD' as const,
    ML: 'XOF' as const,
    MM: 'MMK' as const,
    MN: 'MNT' as const,
    MO: 'MOP' as const,
    MP: 'USD' as const,
    MQ: 'EUR' as const,
    MR: 'MRO' as const,
    MS: 'XCD' as const,
    MT: 'EUR' as const,
    MU: 'MUR' as const,
    MV: 'MVR' as const,
    MW: 'MWK' as const,
    MX: 'MXN' as const,
    MY: 'MYR' as const,
    MZ: 'MZN' as const,
    NA: 'NAD' as const,
    NC: 'XPF' as const,
    NE: 'XOF' as const,
    NF: 'AUD' as const,
    NG: 'NGN' as const,
    NI: 'NIO' as const,
    NL: 'EUR' as const,
    NO: 'NOK' as const,
    NP: 'NPR' as const,
    NR: 'AUD' as const,
    NU: 'NZD' as const,
    NZ: 'NZD' as const,
    OM: 'OMR' as const,
    PA: 'PAB' as const,
    PE: 'PEN' as const,
    PF: 'XPF' as const,
    PG: 'PGK' as const,
    PH: 'PHP' as const,
    PK: 'PKR' as const,
    PL: 'PLN' as const,
    PM: 'EUR' as const,
    PN: 'NZD' as const,
    PR: 'USD' as const,
    PS: 'ILS' as const,
    PT: 'EUR' as const,
    PW: 'USD' as const,
    PY: 'PYG' as const,
    QA: 'QAR' as const,
    RE: 'EUR' as const,
    RO: 'RON' as const,
    RS: 'RSD' as const,
    RU: 'RUB' as const,
    RW: 'RWF' as const,
    SA: 'SAR' as const,
    SB: 'SBD' as const,
    SC: 'SCR' as const,
    SD: 'SDG' as const,
    SE: 'SEK' as const,
    SG: 'SGD' as const,
    SH: 'SHP' as const,
    SI: 'EUR' as const,
    SJ: 'NOK' as const,
    SK: 'EUR' as const,
    SL: 'SLL' as const,
    SM: 'EUR' as const,
    SN: 'XOF' as const,
    SO: 'SOS' as const,
    SR: 'SRD' as const,
    SS: 'SSP' as const,
    ST: 'STN' as const,
    SV: 'USD' as const,
    SX: 'ANG' as const,
    SY: 'SYP' as const,
    SZ: 'SZL' as const,
    TC: 'USD' as const,
    TD: 'XAF' as const,
    TF: 'EUR' as const,
    TG: 'XOF' as const,
    TH: 'THB' as const,
    TJ: 'TJS' as const,
    TK: 'NZD' as const,
    TL: 'USD' as const,
    TM: 'TMT' as const,
    TN: 'TND' as const,
    TO: 'TOP' as const,
    TR: 'TRY' as const,
    TT: 'TTD' as const,
    TV: 'AUD' as const,
    TW: 'TWD' as const,
    TZ: 'TZS' as const,
    UA: 'UAH' as const,
    UG: 'UGX' as const,
    UM: 'USD' as const,
    US: 'USD' as const,
    UY: 'UYU' as const,
    UZ: 'UZS' as const,
    VA: 'EUR' as const,
    VC: 'XCD' as const,
    VE: 'VEF' as const,
    VG: 'USD' as const,
    VI: 'USD' as const,
    VN: 'VND' as const,
    VU: 'VUV' as const,
    WF: 'XPF' as const,
    WS: 'WST' as const,
    YE: 'YER' as const,
    YT: 'EUR' as const,
    ZA: 'ZAR' as const,
    ZM: 'ZMK' as const,
    ZW: 'ZWL' as const,
};
